import { render, staticRenderFns } from "./DocumentRuleTable.vue?vue&type=template&id=92469038&"
import script from "./DocumentRuleTable.vue?vue&type=script&lang=js&"
export * from "./DocumentRuleTable.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRuleTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports